import React from 'react';
import ServiceCard from '../components/ServiceCard';
import { servicesData } from '../mock';

const ServicesPage = () => {
  return (
    <div className="page-container">
      <section className="services-hero">
        <h1 className="page-title">Nossos Serviços</h1>
        <p className="page-subtitle">
          Soluções enterprise completas para proteger e potencializar sua infraestrutura tecnológica
        </p>
      </section>

      <section className="services-detail-section">
        <div className="services-detail-grid">
          {servicesData.map((service) => (
            <ServiceCard key={service.id} service={service} detailed={true} />
          ))}
        </div>
      </section>

      <section className="services-cta-section">
        <div className="services-cta-content">
          <h2 className="services-cta-title">
            Precisa de uma solução personalizada?
          </h2>
          <p className="services-cta-text">
            Nossa equipe está pronta para desenvolver a solução ideal para as necessidades do seu negócio.
          </p>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;